import axiosInstance from "./axiosInstance";
import { get_mentee_data } from "../utils/common";
import { Chat, Chats, Seed, caselet } from "../utils/appConstant";

export async function getRequest(): Promise<any> {
  return await axiosInstance.get("https://reqres.in/api/users");
}

export async function getFiles(): Promise<any> {
  return await axiosInstance.get(`/${Chats}`);
}

export async function getFileChats(fileName: string | undefined): Promise<any> {
  return await axiosInstance.get(`/${Chat}/${fileName}`);
}

export async function generateChat(fileName: string | undefined, prompt: string): Promise<any> {
  const mentee_id = get_mentee_data().mentee_id;
  return await axiosInstance.post(`/${Chat}/${fileName}`, {
    query: prompt,
    // userName: userId,
    mentee_id: mentee_id
  });
}

export async function getSeedFileInfo(fileName: string | undefined): Promise<any> {
  return await axiosInstance.get(`/${Seed}/${fileName}`);
}

export async function getPublishedCaseletsFiles(): Promise<any> {
  return await axiosInstance.get(`/${caselet}`);
}

export async function getPublishedCaseletFileInfo(fileName: string | undefined): Promise<any> {
  return await axiosInstance.get(`/${caselet}/${fileName}`);
}

export async function getId(): Promise<any> {
  return await axiosInstance.get("/generateId");
}

export async function checkFile(id: string | undefined): Promise<any> {
  return await axiosInstance.get(`/checkfile/${id}`);
}

export async function checkUser(): Promise<any> {
  return await axiosInstance.get(`/check_user`);
}

// export async function searchCaseletAPI(searchText: string): Promise<any> {
//   return await axiosInstance.post('/searchCaselet', { searchText });
// }

// export async function caseletEngagement(caselet_id: string, mentor_name: string, mentee_name: string): Promise<any> {
//   return await axiosInstance.post('/caseletEngagement', {
//     caselet_id,
//     mentor_name,
//     mentee_name,
//   });
// }
export async function loginThroughUUID(params: string) {
  return await axiosInstance.get(`/login_through_uuid?uuid=${params}`);
}
export async function ChatFeedBack(fileName: string | undefined, chatFeedBack: string, chatIndexValue?: number): Promise<any> {
  const userId = get_mentee_data().email;
  const mentee_id = get_mentee_data().mentee_id;
  return await axiosInstance.post(`/${Chat}/feedback`, {
    user_id: userId,
    file_name: fileName,
    feed_back: chatFeedBack,
    index_value: chatIndexValue,
    mentee_id: mentee_id
  });
}

export async function registerUsers(userName: string, emailId: string): Promise<any> {
  return await axiosInstance.post("/token/register", {
    name: userName,
    email: emailId
  });
}

export async function loginUsers(emailId: string, password: string): Promise<any> {
  return await axiosInstance.post("/token/auth", {
    email: emailId,
    password: password
  });
}

export async function resetUserPassword(emailId: string, currentPassword: string, newPassword: string): Promise<any> {
  return await axiosInstance.put("/token/reset", {
    email: emailId,
    current_password: currentPassword,
    new_password: newPassword
  });
}

export async function logoutUsers(): Promise<any> {
  return await axiosInstance.delete("/token/delete");
}

export async function forgotUserPassword(emailId: string): Promise<any> {
  return await axiosInstance.put("/token/forgot", {
    email: emailId
  });
}

export async function getUserExitsInParticipantTable(uuid: string): Promise<any> {
  return await axiosInstance.get(`/token/check_exits_user?uuid=${uuid}`);
}

export async function getContextFromCacheMetaDataFile(): Promise<any> {
  return await axiosInstance.get(`/context`);
}

export async function setContextInCacheMetaDataFile(contextValue: String): Promise<any> {
  return await axiosInstance.put(`/context`, {
    context: contextValue
  });
}

export async function getContextFromChatMetaDataFile(conversation_id: String): Promise<any> {
  return await axiosInstance.get(`/context/${conversation_id}`);
}

export async function getCitationInfo(fileName: string | undefined): Promise<any> {
  return await axiosInstance.get(`/citation/${fileName}`);
}
export async function getPodcastCitationInfo(citation: string): Promise<any> {
  return await axiosInstance.get(`/podcast/summary`, {
    params: {
      citation: citation
    }
  });
}

export async function getBookCitationInfo(citation: string, book_name:string): Promise<any> {
  return await axiosInstance.get(`/book/pages`, {
    params: {
      book_name:book_name,
      chapter: citation
    }
  });
}


export async function loginThroughGoogleAuth(code:string): Promise<any> {
  return await axiosInstance.post("/token/google_auth", {
    code: code
  });
}

export async function maintenance_info():Promise<any>{
  return await axiosInstance.get(`/token/maintenance_info`);
}